"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInfoFactoryFromJS = exports.FileInfoFactory = void 0;
const immutable_1 = require("immutable");
const IProjectInfo_1 = require("./IProjectInfo");
exports.FileInfoFactory = (0, immutable_1.Record)({
    id: null,
    projectVersion: null,
    projectId: null,
    projectInfo: (0, IProjectInfo_1.ProjectInfoFactory)()
});
const FileInfoFactoryFromJS = function (data) {
    return (0, exports.FileInfoFactory)(Object.assign(Object.assign({}, data), { projectInfo: (0, IProjectInfo_1.ProjectInfoFactoryFromJS)(data.projectInfo) }));
};
exports.FileInfoFactoryFromJS = FileInfoFactoryFromJS;
//# sourceMappingURL=IFileInfo.js.map